import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { NavLink, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import Expand from '@components/Icon/Expand'
import Collapse from '@components/Icon/Collapse'
import AccountList from './AccountList'
import OfficeList from './OfficeList'

class ParentAccountList extends Component {
  static propTypes = {
    clientRecordsSearchStore: PropTypes.object,
    activeTab: PropTypes.string,
    parentAccounts: PropTypes.object
  }

  isParentAccountFilterActive = () => {
    return this.props.activeTab === 'Parent account'
  }

  renderParentAccountList (activeTab, parentAccounts) {
    const classes = this.isParentAccountFilterActive()
      ? ''
      : 'client-search-list-item-all--parentaccount'

    return parentAccounts.map(parent => (
      <div key={parent.id} className='client-search-list-item'>
        <div className={classes}>
          {this.renderExpandToggle(parent)}
          {this.renderNavLink(parent)}
        </div>
        {activeTab === 'All' && this.renderAccounts(parent, activeTab)}
      </div>
    ))
  }

  renderExpandToggle (parent, isParentAccountFilterActive) {
    if (this.isParentAccountFilterActive(isParentAccountFilterActive)) {
      return null
    }

    return parent.expanded ? (
      <Collapse
        onClick={() => {
          parent.expanded = false
        }}
      />
    ) : (
      <Expand
        onClick={() => {
          parent.expanded = true
        }}
      />
    )
  }

  renderNavLink (parent) {
    if (this.isParentAccountFilterActive()) {
      return (
        <NavLink
          to={`/client-search/parent-account/${parent.id}`}
          activeStyle={{ color: '#ff6d2a' }}
        >
          <p className='client-search-list-item--parentaccount'>
            {parent.parentAccountName}
          </p>
        </NavLink>
      )
    } else {
      return (
        <NavLink
          to={`/client-search/parent-account/${parent.id}`}
          activeStyle={{ color: '#ff6d2a' }}
        >
          <p className='client-search-list-item-all'>
            {parent.parentAccountName}
          </p>
        </NavLink>
      )
    }
  }

  renderAccounts (parent) {
    if (parent.expanded) {
      return <AccountList accounts={parent.accounts} />
    }
  }

  render () {
    const { parentAccounts, activeTab } = this.props
    const { accounts, offices } = this.props.clientRecordsSearchStore

    const shouldRenderList =
      activeTab === 'All' || activeTab === 'Parent account'

    return (
      <div className='client-search-list'>
        {shouldRenderList &&
          this.renderParentAccountList(activeTab, parentAccounts)}
        {activeTab === 'Account' && (
          <AccountList accounts={accounts} activeTab={activeTab} />
        )}
        {activeTab === 'Office' && (
          <OfficeList offices={offices} activeTab={activeTab} />
        )}
      </div>
    )
  }
}

export default withRouter(observer(ParentAccountList))
